import type { FaireProductEntity } from "../../entity_types/product";

export const p_r2crdbj5ev: FaireProductEntity = {
  token: "p_r2crdbj5ev",
  type: "product",
  name: "LE GRAND DRESDEN",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/6dd37876a892092241e4a7047336a552f3c5f98feb419a481b935f7b9159866d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16e56d610c5bda84e530d51fe303f972c98a41272abbbb066ac9a07ebf5d9e86.jpeg",
    "https://cdn.faire.com/fastly/256508761bce069e0d169b18cbc4be2bd381ca960ab4f79372f339129fd03241.jpeg",
    "https://cdn.faire.com/fastly/527fd26c4d77a262b84a4fe8bcff639ca6d26c9b338c7226d6f622cb503f3dd8.jpeg",
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/fc7d35083e3f0bfd4c0eacd8e98b308e15869538e9718afef443f94d32b367a6.jpeg"
  ],
  priceDollars: 30,
  description: "Le Grand Dresden, 14 oz of your favorite scent!\n\nSmells like an old Hollywood secret, dimly lit bar and crisp cocktail. This scent walks the line between fresh and moody. Citrusy notes are softened by warm oud and a hint of black pepper. It's not quite fresh, not quite woody - just unmistakably cool.\n\n• kaffir lime\n• wild bergamot\n• marjoram\n• cracked pepper\n• oud\n\n• Roen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.\n• We use lead-free cotton wicks and premium fragrance oils.\n• All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n• 14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:11.274Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
